<div class="layout-topbar">
  <p-toast key="topbar" [style]="{marginTop: '70px'}"></p-toast>

  @if (appMain.isHorizontal() && !appMain.isMobile()) {
    <a routerLink="/" class="topbar-logo">
      <img alt="logo" src="assets/layout/images/logo-slim.png" />
      <span class="app-name">AOS DB</span>
    </a>
  }

  <img alt="logo" src="assets/layout/images/logo-slim.png" class="mobile-logo"/>

  <a href="#" class="menu-btn" (click)="appMain.onMenuButtonClick($event)">
    <i class="pi pi-bars"></i>
  </a>

  <a href="#" class="topbar-menu-btn" (click)="appMain.onTopbarMobileMenuButtonClick($event)">
    <i class="pi pi-user"></i>
  </a>

  <div class="layout-topbar-menu-wrapper">
    <ul class="topbar-menu fadeInDown" [ngClass]="{'topbar-menu-active': appMain.topbarMenuActive}" (click)="appMain.onTopbarMenuClick($event)">
      <li #profile class="profile-item" [ngClass]="{'active-topmenuitem': appMain.activeTopbarItem === profile}" (click)="appMain.onTopbarRootItemClick($event, profile)">
        <a href="#">
          <span class="profile-image-wrapper">
            <img [email]="user.email" ngxGravatar/>
          </span>
          <span class="topbar-item-name profile-name">{{user.username}}</span>
        </a>
        <ul class="fadeInDown">
          <li role="menuitem">
            <a (click)="openChangePasswordDialog()" href="javascript: void(0);">
              <i class="pi pi-key"></i>
              <span>Zmena hesla</span>
            </a>
          </li>
          <li role="menuitem">
            <a (click)="logout()" href="javascript: void(0);">
              <i class="pi pi-power-off"></i>
              <span>Logout</span>
            </a>
          </li>
        </ul>
      </li>
      @if (isSemaforVisible) {
        <li>
          <a href="javascript: void(0);" (click)="refreshLogin()">
            <span class="topbar-icon material-icons" [style]="{'color': (this.can_login ? 'lightgreen' : 'red'), 'font-size': '24px'}">traffic</span>
            <span class="topbar-item-name">Semafor</span>
          </a>
          <span class="topbar-item-name profile-name" style="display: block; color: #E8EAF6">{{last_vm}}</span>
        </li>
      }
      <li #settings [ngClass]="{'active-topmenuitem':appMain.activeTopbarItem === settings}" (click)="appMain.onTopbarRootItemClick($event, settings)">
        <a href="#">
          <i class="topbar-icon pi pi-cog"></i>
          <span class="topbar-item-name">Settings</span>
        </a>
        <ul class="fadeInDown">
          @if (this.user?.isSuperAdmin()) {
            <li role="menuitem">
              <a (click)="resetCanLogin()">
                <span class="material-icons">update</span>
                <span class="ml-1">Resetnúť semafór</span>
              </a>
            </li>
          }
          @if (isSemaforVisible()) {
            <li role="menuitem">
              <a (click)="togglePolling()">
                <span class="material-icons">{{ isPollingDisabled() ? 'play_circle' : 'pause_circle' }}</span>
                <span class="ml-1">{{ isPollingDisabled() ? 'Zapnúť polling semafóru' : 'Vypnúť polling semafóru' }}</span>
              </a>
            </li>
          }
          <!--                    <li role="menuitem" *ngIf="user.isSuperAdmin()">-->
          <!--                        <a (click)="resetStrategies()">-->
          <!--                            <i class="material-icons">refresh</i>-->
          <!--                            <span>Resetnúť strategie</span>-->
        <!--                        </a>-->
      <!--                    </li>-->
    </ul>
  </li>
  <li #searchbox class="search-item" [ngClass]="{'active-topmenuitem':appMain.activeTopbarItem === searchbox}" (click)="appMain.onTopbarRootItemClick($event, searchbox)">
    <span class="p-input-icon-right">
      <input #searchInput type="text" pInputText placeholder="Search" [(ngModel)]="searchText" (keyup)="search()" (keyup.enter)="navigateToFirstSearchRecord()" style="width: 300px"
        (window:keydown.control.shift.f)="searchInput.focus(); appMain.onTopbarRootItemClick($event, searchbox);"
                    pTooltip="
                    Vyhladava podla market.symbol, market.name, strategy.id, strategy.name, portfolio.id, portfolio.name. Enterom sa presunie na prvy z najdenych vysledkov. Musia byt zadane aspon 3 znaky. Stlacenim CTRL+SHIFT+F focusne vyhladavac.">
        <i class="topbar-icon pi pi-search"></i>
      </span>
      <ul class="fadeInDown" style="width: 500px">
        @for (pair of searchResponse; track pair) {
          <li role="menuitem">
            <a [routerLink]="pair.url">
              <i class="pi" [ngClass]="{'pi-th-large': pair.type === 'MARKET', 'pi-chart-bar': pair.type === 'PORTFOLIO', 'pi-chart-line': pair.type === 'STRATEGY'}"></i>
              <span>{{pair.name}}</span>
            </a>
          </li>
        }
      </ul>
    </li>
  </ul>
</div>

<p-dialog [(visible)]="displayChangePassword" [modal]="true" [draggable]="false" [resizable]="false"
          [dismissableMask]="true" [style]="{width: '27rem'}" [breakpoints]="{'480px': '92vw'}"
          styleClass="ds-dialog" (onHide)="resetChangePassword()">
  <ng-template #header>
    <div class="ds-dialog__title">
      <span class="ds-dialog__icon"><i class="pi pi-key"></i></span>
      <div>
        <h3>Zmena hesla</h3>
        <p>Nastavte si nové prihlasovacie heslo.</p>
      </div>
    </div>
  </ng-template>

  <form class="ds-form" (ngSubmit)="submitChangePassword()">
    <div class="ds-field">
      <p-floatlabel variant="on">
        <p-password inputId="oldPassword" name="oldPassword" [(ngModel)]="oldPassword"
                    [feedback]="false" [toggleMask]="true" autocomplete="current-password"></p-password>
        <label for="oldPassword">Staré heslo</label>
      </p-floatlabel>
    </div>

    <div class="ds-field">
      <p-floatlabel variant="on">
        <p-password inputId="newPassword" name="newPassword" [(ngModel)]="newPassword"
                    [toggleMask]="true" autocomplete="new-password"
                    promptLabel="Zadajte heslo" weakLabel="Slabé" mediumLabel="Stredné" strongLabel="Silné"></p-password>
        <label for="newPassword">Nové heslo</label>
      </p-floatlabel>
      @if (newPassword && oldPassword && newPassword === oldPassword) {
        <small class="ds-field__error"><i class="pi pi-exclamation-circle"></i> Nové heslo sa musí líšiť od starého.</small>
      } @else {
        <small class="ds-field__hint"><i class="pi pi-info-circle"></i> Zvoľte dlhé, unikátne heslo.</small>
      }
    </div>

    <div class="ds-field">
      <p-floatlabel variant="on">
        <p-password inputId="confirmPassword" name="confirmPassword" [(ngModel)]="confirmPassword"
                    [feedback]="false" [toggleMask]="true" autocomplete="new-password"></p-password>
        <label for="confirmPassword">Potvrdiť nové heslo</label>
      </p-floatlabel>
      @if (confirmPassword && newPassword !== confirmPassword) {
        <small class="ds-field__error"><i class="pi pi-exclamation-circle"></i> Heslá sa nezhodujú.</small>
      }
    </div>

    <!-- Native submit button so Enter works; visible actions live in the footer. -->
    <button type="submit" class="hidden" aria-hidden="true"></button>
  </form>

  <ng-template #footer>
    <button pButton type="button" severity="secondary" [text]="true"
            (click)="displayChangePassword = false"><i class="pi pi-times" pButtonIcon></i><span pButtonLabel>Zrušiť</span></button>
    <button pButton type="button" [loading]="changingPassword"
            (click)="submitChangePassword()"><i class="pi pi-check" pButtonIcon></i><span pButtonLabel>Zmeniť heslo</span></button>
  </ng-template>
</p-dialog>

</div>
